import { useState } from "react"
import type { DayRoute } from "../lib/schedule"
import { DAY_LABELS, type DayName } from "../lib/schedule"

interface RouteCardProps {
  day: DayName
  route: DayRoute
}

export function RouteCard({ day, route }: RouteCardProps) {
  const [imgFailed, setImgFailed] = useState(false)
  const label = DAY_LABELS[day]
  const showImage = route.previewImageUrl && !imgFailed

  return (
    <div className="flex h-full flex-col overflow-hidden bg-brew-bg">
      <a
        href={route.url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Open ${route.title} route externally`}
        className="group flex flex-1 flex-col text-inherit no-underline"
      >
        {showImage ? (
          <div className="relative">
            <div className="absolute inset-x-0 text-center font-bold uppercase py-0.5 bg-brew-surface/50 shadow-inner font-logo">
              {route.title}
            </div>
            <img
              src={route.previewImageUrl}
              alt=""
              className="aspect-4/3 w-full bg-brew-surface object-cover"
              onError={() => setImgFailed(true)}
            />
          </div>
        ) : (
          <div className="flex flex-1 flex-col gap-brew-2 py-brew-3 pb-brew-4">
            <h4 className="font-body text-brew-base font-medium leading-normal group-hover:text-brew-muted">
              {route.title}
            </h4>
          </div>
        )}
      </a>
    </div>
  )
}
